export interface Shipment {
	supplierShipmentNumber: string;
	mill: string;
	millDescription: string;
	qtyShipmentNet: number;
	qtyShipmentBrut: number;
	weightUnitShipment: string;
	dispatchAdviceNumber: string;
	dispatchAdviceDate: string;
	shipmentReferenceQualifier: string;
	shipmentReference: string;
	shipmentDate: string;
	transportReferenceConcat: string;
	carrierNameConcat: string;
	loadingProgramNumber: string;
	transportMode: string;
	transportModeDescription: string;
	destination: string;
	destinationDescription: string;
	soldTo: string;
	soldToDescription: string;
	shipTo: string;
	shipToDescription: string;
	supplierBatchReferenceConcat: string;
	millBatchReferenceConcat: string;
	batchReferenceConcat: string;
	qtyBatchNetConcat: string;
	qtyBatchBrutConcat: string;
	weightUnitBatchConcat: string;
	supplierOrderAndItemConcat: string;
	supplierOrderTypeConcat: string;
	customerOrderAndItemConcat: string;
	steelgradeConcat: string;
	steelgradeDescriptionConcat: string;
	thicknessDimensionConcat: string;
	widthDimensionConcat: string;
	lengthDimensionConcat: string;
	customerArticleReferenceConcat: string;
	cddWeek: string;
	dimension: string;
	supplierBatchReference: string;
	shipmentReferenceDate: string;
	currentLocationConcat: string;
	currentLocationDescriptionConcat: string;
	shipToAddressConcat: string;
	deliveryModeConcat: string;
	deliveryModeDescriptionConcat: string;
	batchStatusConcat: string;
	batchStatusDescriptionConcat: string;
	endUserConcat: string;
	endUserDescriptionConcat: string;
	heatNumberConcat: string;
	millOrderNumberConcat: string;
	packageSerialNumberConcat: string;
	destinationByBoatConcat: string;
	productCategoryStuConcat: string;
	productCategoryStuDescriptionConcat: string;
	serviceLevelConcat: string;
	serviceLevelDescriptionConcat: string;
	supplierInvoiceNumberConcat: string;
	htsCodeConcat: string;
	producedLengthDimensionConcat: string;
	salesQuarterConcat: string;
	sfccConcat: string;
	sfccDescriptionConcat: string;
	choiceConcat: string;
	choiceDescriptionConcat: string;
	productDescriptionStu: string;
	readyToShipDateConcat: string;
	specialStockPartnerConcat: string;
	specialStockPartnerDescriptionConcat: string;
	formConcat: string;
	formDescriptionConcat: string;
	// from orders

	choice: string;
	choiceDescription: string;
	endUser: string;
	endUserDescription: string;
	form: string;
	formDescription: string;
	sfcc: string;
	sfccDescription: string;
	productCategory: string;
	productCategoryDescription: string;
	stockPartner: string;
	stockPartnerDescription: string;
	// from batches

	status: string;
	statusDescription: string;
	batchStatus: string;
	batchStatusDescription: string;
}

export interface AggregateShipment {
	qtyShipmentBrut: number;
	qtyShipmentNet: number;
}

export type FieldOfShipment = keyof Shipment;

export interface ShipmentCard {
	supplierShipmentNumber: string;
	mill: string;
	millDescription: string;
	qtyShipmentNet: number;
	qtyShipmentBrut: number;
	weightUnitBatch: string;
	dispatchAdviceNumber: string;
	dispatchAdviceDate: string;
	shipmentReferenceQualifier: string;
	shipmentReference: string;
	shipmentReferenceDate: string;
	transportMode: string;
	transportModeDescription: string;
	transportReference: string;
	transportReferenceConcat: string;
	destination: string;
	destinationDescription: string;
	soldTo: string;
	soldToDescription: string;
	shipTo: string;
	shipToDescription: string;
	shipmentDate: string;
	supplierBatchReference: string;
	carrierNameConcat: string;
	batches?: ShipmentBatch[];
}

export type FieldOfShipmentCard = keyof ShipmentCard
	| 'dispatchAdviceNumber'
	| 'dispatchAdviceDate';

export interface ShipmentBatch {
	supplierShipmentNumber: string;
	supplierBatchReference: string;
	batchReference: string;
	batchStatusGroup: string;
	batchStatusGroupDescription: string;
	batchStatusCategory: string;
	batchStatusCategoryDescription: string;
	batchStatus: string;
	batchStatusDescription: string;
	currentLocation: string;
	currentLocationDescription: string;
	mill: string;
	millDescription: string;
	form: string;
	formDescription: string;
	producedThicknessDimension: number;
	producedWidthDimension: number;
	producedLengthDimension: number;
	packageSerialNumber: string;
	qtyBatchNet: number;
	qtyBatchBrut: number;
	weightUnitBatch: string;
	heatNumber: string;
	numberOfPieces: string;
	readyToShipDate: string;
	availableInStockDate: string;
	daysInStock: number;
	plannedShipmentDate: number;
}

export type FieldOfShipmentBatch = keyof ShipmentBatch;

export interface ShipmentOrder {
	customerOrderNumber: string;
	customerOrderItemNumber: string;
	supplierOrderNumber: string;
	supplierOrderItemNumber: string;
	steelgrade: string;
	steelgradeDescription: string;
	cdd: string;
	cddWeek: string;
	shipTo: string;
	shipToDescription: string;
	endUser: string;
	endUserDescription: string;
	billTo: string;
	billToDescription: string;
	millOrderReference: string;
	millOrderItemReference: string;
	soldTo: string;
	soldToDescription: string;
}

export type FieldOfShipmentOrder = keyof ShipmentOrder;

export const shipmentCardFields = <const> [
	'dispatchAdviceNumber',
	'dispatchAdviceDate',
	'shipmentReference',
	'shipmentDate',
	'millDescription',
	'transportMode',
	'transportModeDescription',
	'transportReference',
	'mill',
	'destinationDescription',
	'shipToDescription',
	'shipmentReference',
	'shipmentDate',
	'qtyShipmentNet',
	'qtyShipmentBrut',
	'soldToDescription',
	'supplierBatchReference'

];

export const shipmentBatchesFields = <const> [
	'supplierBatchReference',
	'batchReference',
	'supplierShipmentNumber',
	'currentLocationDescription',
	'qtyBatchNet',
	'qtyBatchBrut',
	'formDescription',
	'producedThicknessDimension',
	'producedWidthDimension',
	'producedLengthDimension',
	'batchStatusDescription',
	'batchStatusGroupDescription',
	'millDescription',
	'readyToShipDate'

];

export const shipmentOrdersFields = <const> [
	'supplierOrderNumber',
	'supplierOrderItemNumber'
];
